
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/elasticsearch",
      function () {
        return require("private-next-pages/sources/elasticsearch.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/elasticsearch"])
      });
    }
  